export * from './permissions';
export * from './role-code';
export const APP_NAME = 'Madinah Ar Rasul';
export const APP_VERSION = '1.0.0';

export const API_PREFIX = '/api/v1';

export const ACCESS_TOKEN_TTL = 15 * 60; // 15 menit (detik)
export const REFRESH_TOKEN_TTL = 7 * 24 * 60 * 60; // 7 hari (detik)

export const StatusKehadiran = {
  HADIR: 'hadir',
  IZIN: 'izin',
  SAKIT: 'sakit',
  ALPHA: 'alpha',
} as const;

export type StatusKehadiran = (typeof StatusKehadiran)[keyof typeof StatusKehadiran];

export const ApiPath = {
  API_V1: API_PREFIX,

  AUTH: {
    LOGIN: '/auth/login',
    REGISTER: '/auth/register',
    REGISTER_OPTIONS: '/auth/register-options',
    LOGOUT: '/auth/logout',
    REFRESH: '/auth/refresh',
    ME: '/auth/me',
    UPDATE_ME: '/auth/me',
    CHANGE_PASSWORD: '/auth/change-password',
  },
  SETTINGS: {
    INSTITUTION: '/settings/institution',
    INSENTIF_KEGIATAN: '/master/insentif-kegiatan',
  },

  MASTER: {
    SEKOLAH: '/master/sekolah',
    ROLES: '/master/roles',
    JABATAN: '/master/jabatan',
    PEGAWAI: '/master/pegawai',
    HONOR_PEGAWAI: '/master/honor-pegawai',
  },

  ABSENSI: {
    PERIODE: '/absensi/periode',
    KALENDER: '/absensi/kalender-kerja',
    CHECK_IN: '/absensi/check-in',
    CHECK_OUT: '/absensi/check-out',
    TODAY: '/absensi/today',
    STATUS: '/absensi/status',
    REKAP: '/absensi/rekap',
    RIWAYAT: '/absensi/riwayat',
    LAPORAN: '/absensi/laporan',
    DETAIL: (id: number | string) => `/absensi/${id}`,
    UPDATE_STATUS: '/absensi/status',
    SEND_ALPHA: '/absensi/send-alpha',
  },

  ADMIN: {
    AKUN: '/admin/akun',
    RESET_PASSWORD: (id: number | string) => `/admin/akun/${id}/reset-password`,
    UNLOCK: (id: number | string) => `/admin/akun/${id}/unlock`,
    DEACTIVATE: (id: number | string) => `/admin/akun/${id}/deactivate`,
    REACTIVATE: (id: number | string) => `/admin/akun/${id}/reactivate`,
    AUDIT_LOG: '/admin/audit-log',
    PEGAWAI_ROLE: (id: number | string) => `/admin/pegawai/${id}/roles`,
    PENDING_USERS: '/admin/pending-users',
    PENDING_USER: (id: number | string) => `/admin/pending-users/${id}`,
    APPROVE_PENDING: (id: number | string) => `/admin/pending-users/${id}/approve`,
    REJECT_PENDING: (id: number | string) => `/admin/pending-users/${id}/reject`,
  },
  SYSTEM: {
    SETTINGS: '/admin/system-settings',
    PERMISSIONS: '/admin/permissions',
    JENIS_KOMPONEN_HONOR: '/admin/jenis-komponen-honor',
    KONFIGURASI_HONOR_JABATAN: '/admin/konfigurasi-honor-jabatan',
  },
  HONORARIUM: {
    PERIODE: '/honorarium/periode',
    SLIP: '/honorarium/slip',
    SLIP_SAYA: '/honorarium/slip/saya',
    TOTAL_JP_MENGAJAR: '/honorarium/total-jp-mengajar',
    LAPORAN: '/honorarium/laporan',
    LAPORAN_CSV: '/honorarium/laporan/csv',
    HONOR_BULANAN: '/honorarium/honor-bulanan',
  },
} as const;
